import { css } from 'styled-system/css';

export const newbieMatchStyle = {
	match: css({
		base: {
			py: '6px',
			borderBottom: '1px solid {colors.black.5}',
			_last: {
				borderBottom: 'none',
			}
		}
	}),
	event: css({
		base: {
			display: 'grid',
			gridTemplateColumns: '2fr 1fr',
			px: '9px',
			rowGap: '9px',
			columnGap: '6px',
		},
	}),
	team: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			minH: '39px',
			fontSize: '14px',
		}
	}),
	score: css({
		base: {
			ml: 'auto',
			color: 'secondary.500',
			px: '6px',
			fontWeight: '700',
		}
	}),
	bet: css({
		base: {
			'& .odds-button': {
				minH: '39px',
			}
		}
	}),
	info: css({
		base: {
			display: 'flex',
			justifyContent: 'space-between',
			px: '9px',
			mt: '9px',
		}
	}),
	timer: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			'& .icon': {
				width: '20px',
				height: '20px',
			},
			'& .match-live .text-primary': {
				color: 'minus.text'
			},
			'& .match-time-live': {
				// color: 'minus.text',
				color: 'currentColor',
				pt: '2px',
				height: '18px',
			},
			'& .match-slide__item:nth-child(2)': {
				mt: '-18px',
			}
		},
	}),
	time: css({
		base: {
			mr: '3px',
			ml: '3px',
		},
	}),
	statusTag: css({
		_mars: {
			mt: '0px',
		},
	}),
	moreButton: css({
		base: {
			bgColor: 'primary.400',
			color: 'whiteOpacity.100',
			height: 'auto',
			width: 'auto',
			py: '3px',
			px: '6px',
			fontSize: '12px',
			lineHeight: '15px',
		},
	}),
}